import { Value } from "@convertkit/slate"

/**
 * Make value get retrieved in a predictable priority order below
 * value -> content -> default-content
 * preventing behaviors where a lower priority is displayed over a higher one
 * @param {*string} value - A JSON string value
 * @param {*string} content  - HTML content (HTML nodes or Text node)
 * @param {*object} defaults  - object containing default content
 * @param {*object} serializer  - object of a serializer function and options for JSON
 * @param {*object} parser - object of a parser function and options for parsing content
 */
export function getValue(
  value,
  content,
  defaults,
  serializer = {},
  parser = {}
) {
  let output
  if (value) {
    output = Value.fromJSON(JSON.parse(value))
    if (serializer?.serialize) {
      output = serializer.serialize(output, serializer.options || {})
    }
  } else {
    const defaultContent = defaults?.content ?? ""
    output = content || defaultContent
    if (parser?.parse) {
      output = parser.parse(output, parser.options || {})
    }
  }
  return output
}
